import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { useFortuneData } from '../contexts/FortuneContext';
import '../styles/MyPage.css';

const MyPage = () => {
  const { t } = useTranslation();
  const { currentUser, logout } = useAuth();
  const { getFortuneHistory, clearFortuneData } = useFortuneData();
  const navigate = useNavigate();
  const history = getFortuneHistory();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="my-page">
      <div className="page-header">
        <Link to="/" className="back-button">
          <span>←</span>
        </Link>
        <h1>{t('my_page')}</h1>
      </div>

      <div className="my-page-content">
        {currentUser ? (
          <>
            <div className="user-profile">
              <div className="profile-image" style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span>{currentUser.name ? currentUser.name.charAt(0).toUpperCase() : 'U'}</span>
              </div>
              <div className="profile-info">
                <h2>{currentUser.name}</h2>
                <p>{currentUser.email}</p>
              </div>
            </div>

            <div className="account-actions">
              <button className="logout-button" onClick={handleLogout}>
                {t('logout')}
              </button>
            </div>

            <div className="recent-readings">
              <h3>{t('recent_readings')}</h3>
              
              {history.length > 0 ? (
                <div className="readings-list">
                  {history.slice(0, 3).map(item => (
                    <Link 
                      to={`/history/${item.id}`} 
                      className="reading-item" 
                      key={item.id}
                    >
                      <div className="reading-info">
                        <h4>{t(item.product.titleKey)}</h4>
                        <p className="reading-date">
                          {new Date(item.date).toLocaleDateString()}
                        </p>
                      </div>
                      <span className="reading-arrow">→</span>
                    </Link>
                  ))}
                  
                  {history.length > 3 && (
                    <Link to="/history" className="view-all-link">
                      {t('view_all')}
                    </Link>
                  )}
                </div>
              ) : (
                <div className="no-readings">
                  <p>{t('no_readings_yet')}</p>
                  <Link to="/" className="start-reading-link">
                    {t('start_reading')}
                  </Link>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="login-prompt">
            <p>{t('login_to_view_profile')}</p>
            <Link to="/login" className="login-link">
              {t('login')}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyPage;
